module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("开始使用 VUX 之前")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("如果你刚从后端转到前端，可能会被目前前端(表面的)工程复杂度惊吓到，但是放心，使用 "), _c('code', [_vm._v("vue-cli")]), _vm._v(" 从模板创建项目可以快速开始编码、构建，仅仅是几行简单的命令不是么？")])]), _vm._v(" "), _c('p', [_vm._v("在使用 VUX 之前需要你至少已经会使用 "), _c('code', [_vm._v("Vue")]), _vm._v("，同时需要你大概了解 "), _c('code', [_vm._v("Node.js")]), _vm._v("，"), _c('code', [_vm._v("npm")]), _vm._v("，"), _c('code', [_vm._v("cnpm")]), _vm._v("，"), _c('code', [_vm._v("yarn")]), _vm._v(" 这些东西。")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("建议 "), _c('code', [_vm._v("Node.js")]), _vm._v(" 版本在 "), _c('code', [_vm._v("7.6.0")]), _vm._v(" 以上。")])]), _vm._v(" "), _c('h2', [_vm._v("相关工具")]), _vm._v(" "), _c('h3', [_vm._v("WeUI")]), _vm._v(" "), _c('p', [_vm._v("VUX 样式基于 "), _c('a', {
    attrs: {
      "href": "https://github.com/weui/weui"
    }
  }, [_vm._v("WeUI")]), _vm._v("，但是你不必通过使用 VUX 来使用 "), _c('code', [_vm._v("WeUI")]), _vm._v("。简单的页面你可以直接引入 "), _c('code', [_vm._v("WeUI")]), _vm._v(" 样式。详细请参考 "), _c('a', {
    attrs: {
      "href": "https://github.com/weui/weui"
    }
  }, [_vm._v("WeUI 文档")]), _vm._v("。")]), _vm._v(" "), _c('h3', [_vm._v("Vue")]), _vm._v(" "), _c('p', [_vm._v("VUX 基于 "), _c('code', [_vm._v("Vue")]), _vm._v(" 的组件库，意味着你需要有 "), _c('code', [_vm._v("Vue")]), _vm._v(" 的基础知识。")]), _vm._v(" "), _c('p', [_vm._v("如果还没有了解过，建议先看看"), _c('a', {
    attrs: {
      "href": "https://cn.vuejs.org"
    }
  }, [_vm._v("Vue 官方文档")]), _vm._v("。")]), _vm._v(" "), _c('h3', [_vm._v("Webpack")]), _vm._v(" "), _c('p', [_vm._v("如果你直接使用 "), _c('code', [_vm._v("vux2")]), _vm._v(" 模板，你可以暂时不用了解。当你需要自定义一些配置时自然就能很快了解了。")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://webpack.js.org"
    }
  }, [_vm._v("Webpack 文档")])]), _vm._v(" "), _c('h3', [_vm._v("vue-cli")]), _vm._v(" "), _c('p', [_vm._v("Vue 官方用于快速创建项目的工具。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install vue-cli -g\n")])]), _vm._v(" "), _c('p', [_vm._v("或者使用 yarn")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("yarn global add vue-cli\n")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-cli"
    }
  }, [_vm._v("vue-cli 文档")])]), _vm._v(" "), _c('h3', [_vm._v("vue-loader")]), _vm._v(" "), _c('p', [_vm._v("webpack loader，用于编译 "), _c('code', [_vm._v(".vue")]), _vm._v(" 文件，官方模板已经帮你配置好。")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://vue-loader.vuejs.org"
    }
  }, [_vm._v("vue-loader 文档")])]), _vm._v(" "), _c('h3', [_vm._v("vux-loader")]), _vm._v(" "), _c('p', [_vm._v("VUX 组件库的 webpack loader，实现按需加载等功能。它不是替代 "), _c('code', [_vm._v("vue-loader")]), _vm._v(" 而是配合 "), _c('code', [_vm._v("vue-loader")]), _vm._v(" 使用。如果你使用 vux2 模板，暂不需要手动使用它。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e66321a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-2e66321a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/before-using-vux-29.vue
// module id = 2117
// module chunks = 467